import { List, ListItemButton, styled } from "@mui/material";

interface SideListItemButtonProps {
  compact?: boolean;
}

export const SideListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<SideListItemButtonProps>(({ theme, compact = false }) => ({
  borderRadius: 8,
  padding: compact ? theme.spacing(0.75, 1) : theme.spacing(1),
  minHeight: compact ? 36 : 40,
  height: 'auto',
  color: theme.palette.text.primary,
  ...theme.typography.body2,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& svg': {
    '& path': {
      fill: theme.palette.grey[500],
    },
    width: compact ? 20 : 24,
    height: compact ? 20 : 24,
    flexShrink: 0,
  },
  '& .MuiListItemIcon-root': {
    minWidth: compact ? '32px' : '35px',
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '& svg': {
      '& path': {
        fill: theme.palette.primary.contrastText,
      },
    },
    span: {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
}));

export const SideList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));
